import { useState } from "react";
import { Button, Form, Row, Container, Col, Card } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { ADD_CLIENT, DOMAIN_NAME } from "../../constants";

function AddClients() {

	const [showAlert, setShowAlert] = useState(false);
	
	const [values, setValues] = useState({
		name: '',
		address: '',
		phonenumber: '',
		username: '',
		password: ''
	});

	const set = name => {
		return ({ target: {value} }) => {
			setValues(oldValues => ({...oldValues, [name]: value}));
		}
	}

	const addClientSubmit = async (event) => {
		event.preventDefault();
		console.log(JSON.stringify(values))
		try{
			const response = await fetch(DOMAIN_NAME + ADD_CLIENT, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				},
				body: JSON.stringify(values)
			}).then(response => response.json())
			.then(data => console.log(data));
			setShowAlert(true)
			// console.log(response.json())
		}catch(e) {

		}
	}

	return (
		<Row>
			<Col>
				<Card>
					<Card.Header as="h5">Client Details</Card.Header>
					<Card.Body>
						<Form onSubmit={addClientSubmit}>
							<Form.Group controlId="formClientName">
								<Form.Label>Name</Form.Label>
								<Form.Control type="text" placeholder="Enter Name" value={values.name} onChange={set('name')}/>
							</Form.Group>
							<Form.Group controlId="formClientAddress">
								<Form.Label> Address</Form.Label>
								<Form.Control type="text" placeholder="eg: Mumbai" value={values.address} onChange={set('address')} />
							</Form.Group>
							<Form.Group controlId="formClientContactNo">
								<Form.Label>Contact No</Form.Label>
								<Form.Control type="text" placeholder="eg: 9876543211" value={values.phonenumber} onChange={set('phonenumber')} />
							</Form.Group>
							<Form.Group controlId="formClientName">
								<Form.Label>Username</Form.Label>
								<Form.Control type="text" placeholder="Enter Username" value={values.username} onChange={set('username')} />
							</Form.Group>
							<Form.Group controlId="formBasicPassword">
								<Form.Label>Password</Form.Label>
								<Form.Control type="password" placeholder="Password" value={values.password} onChange={set('password')} />
							</Form.Group>
							<Button variant="primary" type="submit">
								Submit
							</Button>
						</Form>
					</Card.Body>
				</Card>
			</Col>

			{showAlert ?
				<SweetAlert 
					title="Success"
					onConfirm={()=>setShowAlert(false)}
				/>
				:
				<></>
			}
		</Row>

		
	);
}

export default AddClients;